import { useContext } from 'react';
// Import from the existing notification context
import NotificationContext from '../context/notification';

interface Notification {
  id?: string;
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
}

interface NotificationContextValue {
  notifications: Notification[];
  add: (notification: Notification) => void;
  remove: (id: string) => void;
}

export function useNotification() {
  const context = useContext(NotificationContext) as NotificationContextValue | null;

  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }

  return {
    notifications: context.notifications,
    notify: context.add,
    dismiss: context.remove,
  };
}
